import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import classNames from 'classnames';

import Modal from 'components/base/Modal';
import Button, { ButtonLink } from 'components/base/Button';
import { selectCampaign } from 'data/campaigns';
import { campaignPath } from 'app/routes';
import css from './style.scss';


class ModalCampaignCreated extends PureComponent {
  constructor(props) {
    super(props);

    this.handleClose = this.handleClose.bind(this);
  }

  handleClose() {
    const { campaign, history } = this.props;
    history.push(campaignPath(campaign.get('id')));
  }

  render() {
    const { campaign } = this.props;
    const path = campaignPath(campaign.get('id'));
    const btn = { kind: Button.kind.blue, size: Button.size.large, className: classNames(css.button, css.clsButtonCenterAlign) };

    return (
      <Modal isOpen uniqId="CampaignCreated" width="433px" onClose={this.handleClose} modalClassName={css.campaignModal}>
        <div className={classNames(css.modalContainer, css.campaignCreated)}>
          <div className={css.captionheader}>New Campaign Created</div>
          <div className={css.captions}>
            <div className={css.caption}>You have successfully created a new campaign<br /> {`"${campaign.get('name', '')}"`}</div>
            <div className={css.caption}>Here’s what you can do next:</div>
          </div>
          <div className={css.buttons}>
            <ButtonLink {...btn} to={`${path}/website`} className={css.newCampaginbtn}><span className={css.newCampaginLabel}>Setup Website</span></ButtonLink>
            <ButtonLink {...btn} to={`${path}/activity`} className={css.newCampaginbtn}><span className={css.newCampaginLabel}>Add an Activity</span></ButtonLink>
            <ButtonLink {...btn} to={path} className={css.newCampaginbtn}><span className={css.newCampaginLabel}>Campaign Dashboard</span></ButtonLink>
          </div>
        </div>
      </Modal>
    );
  }
}

export default withRouter(connect(state => ({
  campaign: selectCampaign(state),
}))(ModalCampaignCreated));
